export default "__VITE_ASSET__B28cacCf__"